import React, { useEffect, useState } from 'react'
import Select, { StylesConfig } from "react-select";
import TextField from '../../../../../core/common/textFields/TextField';
import { DatePicker } from 'antd';
import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useGetAddendaByIdQuery, useLazyGetAddendaByIdQuery } from '../../../../../services/EndPointsApis';
import NumberField from '../../../../../core/common/textFields/NumberField';
import { InputMask } from '@react-input/mask';
import TextAreaField from '../../../../../core/common/textFields/TextAreaField';
import { useSelector } from 'react-redux';

const CreateNewAdddendum = ({ IsAddendaTrigger, setPreviousStatusAddenda, setAddendaIdForJobScope, isApproved, viewOnly, isReviewed, setStatusOfAddenda, setAmountPaybaleChange, setSalePriceAddendaPrice, comment, addendaUpdated, isSuccess, togglestepperAssignment, selectedAddendaId, isEditing, addendaId, projectLookups, getallActiveUsers, projectId, formik }: any) => {
    const [markup, setmarkup] = useState(0)
    const [inputValueAddenda, setInputValueAddenda] = useState(formik.values.addendaNbr === '' ? "" : formik.values.addendaNbr);
    const [amountPayableUpAccep, setAmountPayableUpAccep] = useState('')
    const [isValueExist, setIsValueExist] = useState(false)
    const date = new Date()
    const userId = useSelector((per: any) => per?.auth?.userDetail?.userAccountID);
    const userName = useSelector((per: any) => per?.auth?.userDetail?.loginName);

    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
        // menuPortal: base => ({ ...base, zIndex: 9999 })
    };
    dayjs.extend(customParseFormat);
    const handleAddendaDateChange = (date: Dayjs | null) => {
        formik?.setFieldValue('addendaDate', date ? date.format('YYYY-MM-DD') : dayjs());
    };


    //Get Addenda By Id 

    // const { data:getAddendaBYId } = useGetAddendaByIdQuery({ Id: projectId })
    const [triggerAddendaById, { data: getAddendaById, isSuccess: addendaIsSuccess }] = useLazyGetAddendaByIdQuery()
    // const isReviewed = getAddendaById?.result?.approvedAndReviewd?.[0]?.status === "Reviewed";

    useEffect(() => {
        if (getAddendaById) {
            setSalePriceAddendaPrice({
                salePrice: getAddendaById?.result?.salePrice ?? 0,
                addendaPrice: getAddendaById?.result?.totalAddendumAmount ?? 0,
            });
        }
    }, [getAddendaById]);

    useEffect(() => {
        if (togglestepperAssignment === true && isEditing === true) {
            triggerAddendaById({ AddendaId: selectedAddendaId, ProjectId: projectId })
            // formik.setFieldValue('comments', comment)
        }
        else if (togglestepperAssignment === true && isEditing === false) {
            triggerAddendaById({ AddendaId: '00000000-0000-0000-0000-000000000000', ProjectId: projectId })
        }
    }, [isEditing, togglestepperAssignment])

    useEffect(() => {
        if (IsAddendaTrigger === false && getAddendaById?.result && isEditing === true) {
            formik.setValues({ ...getAddendaById?.result });
            setStatusOfAddenda(getAddendaById?.result?.status)
            setAddendaIdForJobScope(getAddendaById?.result?.id)
            formik.setFieldValue('previousStatus', getAddendaById?.result?.status)
            setPreviousStatusAddenda(getAddendaById?.result?.status)
            if (formik.values.amountPayableUpAccep === 0) {
                setIsValueExist(true)
            }
            else {
                setIsValueExist(false)
            }
            // setInputValueAddenda(formik.values.addendaNbr)
            // setDisabledata(true)
        } else {
            // setUpdateId(0);
        }
    }, [getAddendaById, isEditing, IsAddendaTrigger]);

    const formatNumber = (value: any) =>
        value ? Number(value).toFixed(2) : "0";

    useEffect(() => {
        if (formik?.values?.costAmount !== 0 || formik?.values?.costAmount !== "") {
            const calculatedMarkup = formik?.values?.saleAmount / formik?.values?.costAmount;
            setmarkup(Number(formatNumber(calculatedMarkup)));
            formik.setFieldValue('addendaMarkUp', Number(formatNumber(calculatedMarkup)));
        } else {
            setmarkup(0);
        }
    }, [formik?.values?.costAmount, formik?.values?.saleAmount]);

    // const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     const rawValue = e.target.value.replace(/,/g, "").trim();
    //     if (rawValue === '') {
    //         formik?.setFieldValue('amtPayableAcceptance', '');
    //     } else if (!isNaN(Number(rawValue))) {
    //         formik?.setFieldValue('amtPayableAcceptance', Number(rawValue));
    //     }

    //     setAmountPaybaleChange(true);
    // };
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const rawValue = e.target.value.replace(/,/g, "").trim();

        // Allow empty string, digits, and one optional dot
        if (rawValue === '' || /^-?\d*\.?\d*$/.test(rawValue)) {
            formik.setFieldValue('amtPayableAcceptance', rawValue);
        }

        setAmountPaybaleChange(true);
    };
    const handleBlurPaybale = () => {
        const val = formik.values.amtPayableAcceptance;
        if (val !== '' && !isNaN(Number(val))) {
            formik.setFieldValue('amtPayableAcceptance', Number(val));
        }
    };

    // useEffect(() => {
    //     if (formik.values.addendaType?.id !== 6 && !isEditing) {
    //         formik.setFieldValue('addendaNbr', '');
    //     }
    // }, [formik.values.addendaType?.id]);

    useEffect(() => {
        if (isSuccess) {
            setInputValueAddenda('')
        }
    }, [isSuccess])


    useEffect(() => {
        if (togglestepperAssignment === false && isEditing === false) {
            setInputValueAddenda('')
        }
    }, [togglestepperAssignment]);
    useEffect(() => {
        if (togglestepperAssignment === true && isEditing === false) {
            formik.setFieldValue("writtenBy.value", userName)
            formik.setFieldValue("writtenBy.id", userId)
            formik.setFieldValue("projectPaymentReceivableList", getAddendaById?.result?.projectPaymentReceivableList)
            // formik.setValues({ ...getAddendaById?.result, writtenBy: { id: userId, value: userName }, projectPaymentReceivableList: getAddendaById?.result?.projectPaymentReceivableList || {} });
        }
    }, [togglestepperAssignment, addendaIsSuccess]);

    const formatComma = (value: string | number) => {
        if (value === '' || value === '-') return value; // support in-progress typing
        const num = Number(value);
        if (isNaN(num)) return value;
        return num.toLocaleString('en-US');
    };
    const [numberWarning, setNumberWarning] = useState(false);

    const handleAddendaKeyDown = (e: any) => {
        const key = e.key;
        if (/^[a-zA-Z]$/.test(key)) {
            setNumberWarning(true);
        } else {
            setNumberWarning(false);
        }
    };

    useEffect(() => {
        if (formik.values?.addendaType?.id !== 6 && isEditing === false) {
            formik.setFieldValue('addendaNbr', "");
            setInputValueAddenda('')
        }
    }, [formik.values?.addendaType])

    return (
        <div className='mt-3 mb-3'>
            {/* <form onSubmit={formik?.handleSubmit()}> */}
            <div className='row align-items-center'>
                <div className="col-md-12 mt-2">
                    <label className="col-form-label">
                        Type <span className="text-danger"> *</span>
                    </label>
                    <Select
                        styles={customStyles}
                        className="select"
                        options={projectLookups?.result?.Lst_AddendumType?.map((option: any) => ({
                            label: option?.value,
                            value: option?.id
                        }))}
                        value={
                            formik.values?.addendaType?.id
                                ? {
                                    value: formik.values?.addendaType?.id,
                                    label: formik.values?.addendaType?.value || '',
                                }
                                : null
                        }
                        onChange={(selectedOption: any) => {
                            formik.setFieldValue("addendaType.value", selectedOption?.label)
                            formik.setFieldValue("addendaType.id", selectedOption?.value)

                        }}
                        isDisabled={isEditing}
                    />
                </div>
                {/* <div className="col-md-6 mt-2">
                    <label className='input-label'>Addenda Number</label>
                    <InputMask mask="FLD-25____"
                        replacement={{ _: /\d/ }}
                        className="form-control"
                        value={
                            (isEditing === false && formik.values?.addendaType?.id === 6) ? inputValueAddenda :
                                formik.values.addendaNbr
                        }
                        disabled={isEditing === true || formik.values?.addendaType?.id !== 6}
                        onChange={(e: any) => { formik.setFieldValue('addendaNbr', e.target.value); setInputValueAddenda(e.target.value); }}
                        // onChange={handleAddendaChange}
                        onKeyDown={handleAddendaKeyDown}

                    />
                    {numberWarning && (
                        <div className="color-red mt-1">Please enter numbers only</div>
                    )}
                </div> */}
                <div className="col-md-6 mt-2">
                    <label className='input-label'>Addenda Number <span className="text-danger"> *</span></label>
                    <InputMask
                        mask="________"
                        replacement={{ _: /\d/ }}
                        className="form-control"
                        value={!isEditing ? inputValueAddenda : formik.values?.addendaNbr}
                        disabled={isEditing === true || formik.values?.addendaType?.id !== 6}
                        onChange={(e: any) => {
                            const raw = e.target.value;
                            setInputValueAddenda(raw);
                        }}
                        onKeyDown={handleAddendaKeyDown}
                        onBlur={() => {
                            const fullValue = `FLD-${inputValueAddenda}`;
                            formik.setFieldValue('addendaNbr', fullValue);

                        }}
                    />
                    {numberWarning && (
                        <div className="color-red mt-1">Please enter numbers only</div>
                    )}
                </div>
                {/* <div className="col-md-6 mt-2">
                    <TextField
                        label="Addenda Number"
                        type="text"
                        maxLength={12}
                        min={6}
                        value={
                            (isEditing === false && formik.values?.addendaType?.id === 6) ? inputValueAddenda :
                                formik.values.addendaNbr
                        }
                        disabled={isEditing === true || formik.values?.addendaType?.id !== 6}
                        onChange={(e: any) => { formik.setFieldValue('addendaNbr', e.target.value); setInputValueAddenda(e.target.value); }}
                    />
                </div> */}
                <div className="col-md-6 mt-2">
                    <label className="col-form-label">
                        Written By <span className="text-danger"> *</span>
                    </label>
                    <Select
                        styles={customStyles}
                        className="select"
                        options={getallActiveUsers?.result?.map((option: any) => ({
                            label: option?.userName,
                            value: option?.userId
                        }))}
                        value={
                            formik.values?.writtenBy?.id
                                ? {
                                    value: formik.values?.writtenBy?.id,
                                    label: formik.values?.writtenBy?.value || '',
                                }
                                : null
                            //  {
                            //     value: userId,
                            //     label: userName
                            // }
                        }
                        // value={
                        //     {
                        //         value: userId,
                        //         label: userName
                        //     }
                        // }
                        onChange={(selectedOption: any) => {
                            formik.setFieldValue("writtenBy.value", selectedOption?.label)
                            formik.setFieldValue("writtenBy.id", selectedOption?.value)
                        }}
                        isDisabled={isReviewed || isApproved || viewOnly}
                    // isDisabled
                    />
                </div>
                <div className="col-md-12">
                    <label className="input-label">
                        Addenda Date <span className="text-danger">*</span>
                    </label>
                    <div className="form-wrap icon-form">
                        <span className="form-icon">
                            <i className="ti ti-calendar-check" />
                        </span>
                        <DatePicker
                            className="form-control datetimepicker deals-details"
                            onChange={handleAddendaDateChange}
                            value={formik?.values?.addendaDate ? dayjs(formik?.values?.addendaDate, 'YYYY-MM-DD') : dayjs()}
                            format="MMM-DD-YYYY"
                            disabled={isReviewed || isApproved || viewOnly}
                        />
                    </div>
                </div>

                <h6 className='mt-2'>
                    Financial & Impact:
                </h6>
                <div className="col-md-6 mt-2">
                    {/* <NumberField
                        label="Addenda Sale Amount"
                        type="text"
                        fieldClass="text-end"
                        required
                        min={0}
                        name="saleAmount"
                        formik={formik}
                        value={formik.values.saleAmount}
                    /> */}
                    <TextField
                        type="text"
                        label="Addenda Sale Amount"
                        required
                        maxLength={20}
                        value={formik.values.saleAmount}
                        fieldClass='text-end'
                        onChange={(e) => {
                            const val = e.target.value;
                            if (/^-?\d*\.?\d*$/.test(val) || val === '' || val === '-') {
                                formik.setFieldValue('saleAmount', (val));
                            }
                        }}
                        disabled={isReviewed || isApproved || viewOnly}
                    />
                </div>
                <div className="col-md-6 mt-2">
                    {/* <NumberField
                        label="Addenda Cost Amount"
                        type="text"
                        fieldClass="text-end"
                        required
                        min={0}
                        name="costAmount"
                        formik={formik}
                        value={formik.values.costAmount}
                    /> */}
                    <TextField
                        type="text"
                        label="Addenda Cost Amount"
                        required
                        value={formik.values.costAmount}
                        fieldClass='text-end'
                        onChange={(e) => {
                            const val = e.target.value;
                            if (/^-?\d*\.?\d*$/.test(val) || val === '' || val === '-') {
                                formik.setFieldValue('costAmount', (val));
                            }
                        }}
                        disabled={isReviewed || isApproved || viewOnly}

                    />
                </div>
                <div className="col-md-6 mt-2">
                    <TextField
                        label="Addendum Mark Up"
                        type="number"
                        fieldClass='text-end'
                        min={0}
                        disabled
                        value={markup}
                        {...formik.getFieldProps("addendaMarkUp")}
                    />
                </div>
                <div className="col-md-6 mt-2">
                    <TextField
                        label="Amount Payable Upon Acceptance"
                        type="text"
                        fieldClass="text-end"
                        name="amtPayableAcceptance"
                        value={formik.values.amtPayableAcceptance}
                        onChange={handleInputChange}
                        onBlur={handleBlurPaybale}
                        // disabled={isEditing && isValueExist === true ? true : false}
                        disabled={isReviewed || isApproved || viewOnly}

                    />
                </div>
                <div className="col-md-6 mt-2">
                    <TextAreaField
                        label="Description"
                        type="text"
                        required
                        {...formik.getFieldProps("desc")}
                        disabled={isReviewed || isApproved || viewOnly}


                    />
                </div>
                <div className="col-md-6 mt-2">
                    <TextAreaField
                        label="Internal Description"
                        type="text"
                        required
                        {...formik.getFieldProps("internalDesc")}
                        disabled={isReviewed || isApproved || viewOnly}

                    />
                </div>
                <h6 className='mt-2 mb-2'>
                    Project Impact:
                </h6>
                <div className="col-md-6 d-flex ">
                    <label className="checkboxs mt-2">
                        <input
                            type="checkbox"
                            defaultChecked={false}
                            checked={formik?.values?.isContractLanguage}
                            onChange={() => {
                                const currentValue = formik.values.isContractLanguage;
                                formik.setFieldValue('isContractLanguage', !currentValue);
                                // if (!currentValue) {
                                //     // Only set 'isTimeLine' to false when 'isContractLanguage' is being checked
                                //     formik.setFieldValue('isTimeLine', false);
                                // }
                            }}
                            disabled={isReviewed || isApproved || viewOnly}

                        />
                        <span className="checkmarks" />
                    </label>
                    <label className="input-label">
                        Contract Language
                    </label>
                </div>
                <div className="col-md-6 d-flex">
                    <label className="checkboxs mt-2">
                        <input
                            type="checkbox"
                            defaultChecked={false}
                            checked={formik?.values?.isTimeLine}
                            onChange={() => {
                                const currentValue = formik.values.isTimeLine;
                                formik.setFieldValue('isTimeLine', !currentValue);
                                // if (!currentValue) {
                                //     // If isTimeLine is checked, uncheck isContractLanguage
                                //     formik.setFieldValue('isContractLanguage', false);
                                // }
                            }}
                            disabled={isReviewed || isApproved || viewOnly}

                        />
                        <span className="checkmarks" />
                    </label>
                    <label className="input-label">
                        Timeline
                    </label>
                </div>
                {formik.values.isTimeLine === true &&
                    <>

                        <h6 className='mt-2 mb-2'>
                            TimeLine Impact Ranges(in days):
                        </h6>
                        <div className="col-md-6 mt-2">
                            <TextField
                                label="Internal Duration"
                                type="number"
                                value={formik.values.internalDurationTimeLine === 0 ? "" : formik.values.internalDurationTimeLine}
                                onChange={(e) =>
                                    formik.setFieldValue(
                                        "internalDurationTimeLine",
                                        e.target.value === "" ? 0 : Number(e.target.value)
                                    )
                                }
                                disabled={isReviewed || isApproved || viewOnly}

                            />
                        </div>
                        <div className="col-md-6 mt-2">
                            <TextField
                                label="External Duration"
                                type="number"
                                value={formik.values.externalDurationTimeLine === 0 ? "" : formik.values.externalDurationTimeLine}

                                onChange={(e) =>
                                    formik.setFieldValue(
                                        "externalDurationTimeLine",
                                        e.target.value === "" ? 0 : Number(e.target.value)
                                    )
                                }
                                disabled={isReviewed || isApproved || viewOnly}

                            />
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="radio-wrap">
                                <div className="d-flex flex-wrap">
                                    <div className="radio-btn">
                                        <input
                                            type="radio"
                                            className="status-radio addenda-radio"
                                            id="active"
                                            name="active"
                                            value="true"
                                            checked={formik?.values?.timeLineIsProjDevelopment}
                                            onChange={() => {
                                                formik.setFieldValue('timeLineIsProjDevelopment', true);
                                                formik.setFieldValue('timeLineIsFieldProduction', false);
                                            }}
                                            disabled={isReviewed || isApproved || viewOnly}

                                        />
                                        <label htmlFor="active">Project Developement</label>
                                    </div>
                                    <div className="radio-btn">
                                        <input
                                            type="radio"
                                            className="status-radio addenda-radio"
                                            id="inactive"
                                            name="active"
                                            value="true"
                                            checked={formik.values.timeLineIsFieldProduction}
                                            onChange={() => {
                                                formik.setFieldValue('timeLineIsProjDevelopment', false);
                                                formik.setFieldValue('timeLineIsFieldProduction', true);
                                            }}
                                            disabled={isReviewed || isApproved || viewOnly}

                                        />
                                        <label htmlFor="inactive">Field Production</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {(!formik?.values?.timeLineIsProjDevelopment === false || !formik?.values?.timeLineIsFieldProduction === false) &&
                            <div className='col-md-12 mt-2 mb-5'>
                                <Select
                                    styles={customStyles}
                                    className="select"
                                    // menuPortalTarget={document.body}
                                    options={
                                        formik?.values?.timeLineIsProjDevelopment === true
                                            ? projectLookups?.result?.Lst_ContractReview?.map((option: any) => ({
                                                label: option?.value,
                                                value: option?.id,
                                            }))
                                            : formik?.values?.timeLineIsFieldProduction === true
                                                ? projectLookups?.result?.Lst_SubstantialComplete?.map((option: any) => ({
                                                    label: option?.value,
                                                    value: option?.id,
                                                }))
                                                : []
                                    }
                                    value={
                                        formik?.values?.timeLineIsProjDevelopment
                                            ? formik.values?.lst_ContractReview?.id
                                                ? {
                                                    value: formik.values?.lst_ContractReview?.id,
                                                    label: formik.values?.lst_ContractReview?.value || '',
                                                }
                                                : null
                                            : formik?.values?.timeLineIsFieldProduction
                                                ? formik.values?.lst_SubstantialComplete?.id
                                                    ? {
                                                        value: formik.values?.lst_SubstantialComplete?.id,
                                                        label: formik.values?.lst_SubstantialComplete?.value || '',
                                                    }
                                                    : null
                                                : null
                                    }
                                    onChange={(selectedOption: any) => {
                                        if (formik?.values?.timeLineIsProjDevelopment) {
                                            formik.setFieldValue("lst_ContractReview.value", selectedOption?.label || '');
                                            formik.setFieldValue("lst_ContractReview.id", selectedOption?.value || null);
                                        } else if (formik?.values?.timeLineIsFieldProduction) {
                                            formik.setFieldValue("lst_SubstantialComplete.value", selectedOption?.label || '');
                                            formik.setFieldValue("lst_SubstantialComplete.id", selectedOption?.value || null);
                                        }
                                    }}
                                    isDisabled={isReviewed || isApproved || viewOnly || formik?.values?.timeLineIsFieldProduction === true}
                                />
                            </div>
                        }
                    </>
                }
            </div>
            {/* </form> */}
        </div>
    )
}

export default CreateNewAdddendum